// 保存该模块下的路由信息
const routerArr = [{//应急---危化品培训
	path: '/yj_s_register',
	name: 'yj_s_register',
	meta: {
		title: '注册',
		login: false
	},
	component: () => import( /* webpackChunkName: 'yj_s_register' */ './account/sRegister.vue'),
},
//应急---工贸培训
{
	path: '/yj_gm_register',
	name: 'yj_gm_register',
	meta: {
		title: '注册',
		login: false
	},
	component: () => import( /* webpackChunkName: 'yj_gm_register' */ './account/gmRegister.vue'),
},
//应急---森林防火培训
{
	path: '/yj_slfh_register',
	name: 'yj_slfh_register',
	meta: {
		title: '注册',
		login: false
	},
	component: () => import( /* webpackChunkName: 'yj_slfh_register' */ './account/slfhRegister.vue'),
},

{
	path: '/yj_common_register',
	name: 'yj_common_register',
	meta: {
		title: '注册',
		login: false
	},
	component: () => import( /* webpackChunkName: 'yj_common_register' */ './account/commonRegister.vue'),
},
//非煤---工贸培训
{
	path: '/yj_fm_register',
	name: 'yj_fm_register',
	meta: {
		title: '注册',
		login: false
	},
	component: () => import( /* webpackChunkName: 'yj_gm_register' */ './account/feimeiRegister.vue'),
},

//ysx---工贸培训
{
	path: '/yj_ysx_register',
	name: 'yj_ysx_register',
	meta: {
		title: '注册',
		login: false
	},
	component: () => import( /* webpackChunkName: 'yj_ysx_register' */ './account/ysxRegister.vue'),
},
// 全员定向大培训 - 项目选择页面（定制）
{
	path: '/yj_training_options',
	name: 'yj_training_options',
	meta: {
		title: '全员定向大培训',
		login: false,
	},
	component: () => import( /* webpackChunkName: 'yj_training_options' */ './trainingOptions/trainingOptions.vue'),
}
]
export default routerArr
